import React, { useContext } from 'react';

import { Box, Typography } from '@mui/material';

import ConfigsContext from '../../Container/Config/ConfigsContext';
import TranslationsContext from '../../Container/Language/TranslationsContext';
import LayoutConfigContext from './LayoutConfigContext';

const SECOND_LEVEL_LABELS = ['com', 'co', 'org', 'net', 'gov', 'edu', 'ac'];

export const NEW_CABINET_BANNER_HEIGHT = 36;

export const resolveNewCabinetUrl = (hostname, project, siteId) => {
  if (project !== 'interconnect' && [1, 3, 4, 57].indexOf(Number(siteId)) === -1) return null;

  const host = String(hostname || '').toLowerCase().replace(/^www\./, '').split(':')[0];
  const parts = host.split('.').filter(Boolean);

  if (parts.length < 2 || parts[0] === 'cabinet') return null;

  const tld = parts[parts.length - 1];
  const sld = parts[parts.length - 2];
  const compound = tld.length === 2 && SECOND_LEVEL_LABELS.includes(sld);
  const take = compound && parts.length >= 3 ? 3 : 2;
  const domain = parts.slice(-take).join('.');

  if (host === `cabinet.${domain}`) return null;

  return `https://cabinet.${domain}`;
};

export const useNewCabinetUrl = () => {
  const { data: configs } = useContext(ConfigsContext);

  return resolveNewCabinetUrl(
    configs?.hostname || window.location.hostname,
    configs?.project,
    configs?.site || configs?.siteId,
  );
};

export const NewCabinetBannerOffset = () => {
  const url = useNewCabinetUrl();

  if (!url) return null;

  return <Box sx={{ height: NEW_CABINET_BANNER_HEIGHT, flexShrink: 0 }} />;
};

const NewCabinetBanner = () => {
  const { t } = useContext(TranslationsContext);
  const { colors } = useContext(LayoutConfigContext);
  const url = useNewCabinetUrl();

  if (!url) return null;

  const title = t('app:layout:new-cabinet:title');
  const button = t('app:layout:new-cabinet:button');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        width: '100%',
        height: NEW_CABINET_BANNER_HEIGHT,
        minHeight: NEW_CABINET_BANNER_HEIGHT,
        px: 2,
        boxSizing: 'border-box',
        backgroundColor: colors?.linkColor || '#669966',
        color: '#fff',
        overflow: 'hidden',
      }}
    >
      <Typography
        component="span"
        noWrap
        sx={{
          minWidth: 0,
          fontSize: 13,
          fontWeight: 500,
          lineHeight: 1.2,
          color: 'inherit',
        }}
      >
        {title}
      </Typography>
      <Box
        component="a"
        href={url}
        sx={{
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          height: 22,
          px: 1.25,
          borderRadius: '11px',
          backgroundColor: '#fff',
          color: colors?.linkColor || '#2f4a34',
          fontSize: 12,
          fontWeight: 600,
          lineHeight: 1,
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          '&:hover': { backgroundColor: '#f4f7f4' },
        }}
      >
        {button}
      </Box>
    </Box>
  );
};

export default NewCabinetBanner;
